import { Product } from '@/src/types/api-types'
import { ProductsBasket } from '@/type/basket'

const getProductDeclination = (product: Product | ProductsBasket) => {
  const productDeclinationName = product.variation_features?.map(i => i.variant).join(' - ')

  const productName = `${product.product}${
    productDeclinationName ? ` - ${productDeclinationName}` : ''
  }`

  return { productName }
}

export default getProductDeclination
